export const FETCH_PACKAGE_ORDER_DETAIL_PENDING =
  'FETCH_PACKAGE_ORDER_DETAIL_PENDING';
export const FETCH_PACKAGE_ORDER_DETAIL_REJECTED =
  'FETCH_PACKAGE_ORDER_DETAIL_REJECTED';
export const FETCH_PACKAGE_ORDER_DETAIL_FULFILLED =
  'FETCH_PACKAGE_ORDER_DETAIL_FULFILLED';
export const SET_PACKAGE_ORDER_DETAIL_SELECTED_IDS =
  'SET_PACKAGE_ORDER_DETAIL_SELECTED_IDS';



// WEBPACK FOOTER //
// ./src/constants/packageOrderDetail.js